import { Observable } from 'rxjs';
import { User } from '../models';

export abstract class UserRepositoryPort {
  abstract list(): Observable<User[]>;
  abstract getCurrent(): Observable<User | null>;
  abstract getById(id: string): Observable<User | null>;
  abstract getByPhone(phoneNumber: string): Observable<User | null>;
}
